import React, { useState, useEffect, useRef } from 'react';
import "../Layout/Layout.css";
import "../Layout/product1.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBasketShopping, faCartShopping } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

function Product1({ product }) {

const [windowWidth, setWindowWidth] = useState(window.innerWidth);
useEffect(() => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);
const unit =[
  {id:1,product:1,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 10 viên"},
  {id:2,product:1,unit:"Vỉ",price:40000,note:"vỉ x 10 viên"},
  {id:3,product:1,unit:"Viên",price:2000,note:"1 viên"},
  {id:4,product:2,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:5,product:2,unit:"Gói",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:6,product:3,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:7,product:4,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:8,product:4,unit:"Vỉ",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:9,product:4,unit:"Ống",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:10,product:5,unit:"Ống",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:11,product:6,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:12,product:6,unit:"Vỉ",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:13,product:6,unit:"Ống",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:14,product:7,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:15,product:8,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:16,product:8,unit:"Vỉ",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:17,product:8,unit:"Viên",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:18,product:9,unit:"Hộp",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
  {id:19,product:9,unit:"Gói",price:200000,note:"Hộp 6 vỉ x 5 Ống"},
];
const isScreen = windowWidth > 768;
const content = isScreen ? <Desktop product={product} unit={unit}/> : <Mobile />;

return (
  <body>
    {content}
  </body>
);
};
const Desktop = ({product,unit}) => {
  const [clickedunit, setClickedunit] = useState(null);
  const units = unit.filter((unit) => unit.product === product.id);
  const firstUnitId = units.length > 0 ? units[0].id : null;
  const [selectedColor, setSelectedColor] = useState(firstUnitId);
  ;
  const handleColorChange = (unit) =>{
    setClickedunit(unit);
    setSelectedColor(unit);
  };
return (
  <body class='form-product-1' key={product.id}>
          <div class='form-product-img'>
            <img src={`/imges/${product.img}`} alt=''></img>
            {/* {product.discount === 0 ?
              <>
              
              </>
              :
              <>
              <div class='form-product-body-discount'>
                <p>{product.discount} %</p>
              </div>
              </>
            }   */}
          </div>
          <div class='form-product-body'>
            
            <div class='form-product-body-name'>  
              <span>{product.name}</span>
            </div>
            <div class='form-product-body-price'>
              <div>
                {(clickedunit === null)?
                  unit.filter(unit =>  unit.product === product.id).slice(0, 1).map(unit =>
                    <>
                      {(product.discount === 0) ? 
                        <>
                          <h3 style={{color:"#FF751A"}}>{unit.price.toLocaleString('vi-VN') + "đ / " + unit.unit}</h3>
                          <p>{unit.note}</p>
                        </>
                        : 
                        <>
                          <h3><s>{unit.price.toLocaleString('vi-VN') + "đ / " + unit.unit}</s></h3>
                          <h3 style={{color:"#FF751A"}}>{((unit.price) - ((unit.price * product.discount) / 100 )).toLocaleString('vi-VN') + "đ / " + unit.unit}</h3> 
                          <p>{unit.note}</p>
                        </>
                      }
                    </>
                  )
                  :
                  unit.filter(unit =>  (unit.id === clickedunit)).map(unit =>
                    <>
                      {(product.discount === 0) ? 
                        <>
                          <h3 style={{color:"#FF751A"}}>{unit.price.toLocaleString('vi-VN') + "đ / " + unit.unit}</h3>
                          <p>{unit.note}</p>
                        </>
                        : 
                        <>
                          <h3><s>{unit.price.toLocaleString('vi-VN') + "đ / " + unit.unit}</s></h3>
                          <h3 style={{color:"#FF751A"}}>{((unit.price) - ((unit.price * product.discount) / 100 )).toLocaleString('vi-VN') + "đ / " + unit.unit}</h3> 
                          <p>{unit.note}</p>
                        </>
                      }
                    </>
                  )
                }
              </div>
              <div className='list-button'>
                {unit.filter(id => id.product === product.id).map(unit =>
                  <button onClick={() => handleColorChange(unit.id)} style={{ backgroundColor: selectedColor === unit.id ? "white" : '' ,border: selectedColor === unit.id ? " 1px solid #FF751A" : '' ,color: selectedColor === unit.id ? "#FF751A" : ''}}>{unit.unit}</button>
                )}
              </div>
            </div>
            <div class='form-product-foot'>
                <Link to={`/productDetails/${selectedColor}`} style={{color:"#fff",textDecoration: "none",width:"100%",marginRight:"1%"}}>
                <button>
                    <FontAwesomeIcon icon={faBasketShopping} className='icon-product'/>
                    <span>Thêm giỏ hàng</span>
                </button> 
                </Link>
                <Link to={`/productDetails/${selectedColor}`} style={{color:"#fff",textDecoration: "none",width:"100%",marginLeft:"1%"}}>
                <button >
                    <FontAwesomeIcon icon={faCartShopping} className='icon-product'/>
                    <span>Mua hàng</span>
                </button>
                </Link>
            </div>
          </div> 
  </body>
 );
};
const Mobile = () => {
return (
  <body>
     
  </body>
);
};
export default Product1;



